import { ExtendableImage } from '@design-system/extendable-image';
import { JsonRTE } from '@design-system/json-rte';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import { imageMapper } from '~/mappers/image';

import TMPLinkWrap from '../TMPLinkWrap';
import { JsonRTEBlockProps } from './models';

const ImageWrap =
  (images?: JsonRTEBlockProps['rteImages']) =>
  ({ uid, src, alt, ...attrs }: { uid: string; src: string; alt: string }) => {
    const image = images?.find((item) => item.uid === uid) || { url: src };
    const imageMapped = imageMapper({ image, alt, ...attrs });

    return <ExtendableImage {...imageMapped} />;
  };

const JsonRTEBlock = forwardRef<HTMLDivElement, JsonRTEBlockProps>(
  ({ pageBlockUI, componentId, rte, rteImages }, ref) => (
    <PageBlock
      {...pageBlockUI}
      id={componentId}
      className="json-rte-block"
      ref={ref}
    >
      <JsonRTE
        data={rte}
        linkComponent={TMPLinkWrap}
        imageComponent={ImageWrap(rteImages)}
      />
    </PageBlock>
  )
);

export default JsonRTEBlock;
